import { gql } from 'graphql-request';

/** Shared minimum query length for coffee search (dropdown + results page). */
export const MIN_QUERY_LENGTH = 3;

export const SEARCH_COFFEES_QUERY = gql`
  query SearchCoffees($query: String!, $limit: Int!, $offset: Int!) {
    searchCoffees(query: $query, limit: $limit, offset: $offset) {
      id
      name
      origin
      imageUrl
      roaster {
        id
        name
      }
    }
  }
`;
